export const EMOTIONS = [
  { label: "开心", doubaovalue: "happy" },
  { label: "悲伤", doubaovalue: "sad" },
  { label: "愤怒", doubaovalue: "angry" },
  { label: "恐惧", doubaovalue: "fear" },
  { label: "惊喜", doubaovalue: "surprise" },
  { label: "厌恶", doubaovalue: "disgust" },
  { label: "严肃", doubaovalue: "serious" },
  { label: "温柔", doubaovalue: "gentle" },
  { label: "客服", doubaovalue: "customer_service" },
  { label: "专业", doubaovalue: "professional" },
  { label: "故事", doubaovalue: "storytelling" },
  { label: "电台", doubaovalue: "radio" },
  { label: "撒娇", doubaovalue: "sajiao" },
  { label: "傲娇", doubaovalue: "aojiao" },
  { label: "哭腔", doubaovalue: "kuxiang" },
  { label: "安慰", doubaovalue: "comfort" },
  { label: "抱歉", doubaovalue: "sorry" },
  { label: "愉悦", doubaovalue: "pleasure" }
];

export const EMOTION_MAP = EMOTIONS.reduce((map, item) => {
  map[item.doubaovalue] = item.label;
  return map;
}, {});
